import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import CadastroFechamentoFinanceiro from "./modals/cadastrar";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import { buscarFechamentoFinanceiro } from "../../services/fechamentoFinanceiroService";
import { buscarEmpresa } from "../../services/empresaService";
import { setBuscaFechamentoFinanceiro, setEntityFechamentoFinanceiro, setModalCadastrarFechamentoFinanceiro } from "../../redux/slices/fechamentoFinanceiro/fechamentoFinanceiroSlice";
import { BuscaFechamentoFinanceiroModel } from "../../models/fechamentoFinanceiro/buscaFechamentoFinanceiroModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import dayjs from "dayjs";
import AcoesComponent from "../../components/table/acoesComponent";
import TableComponent from "../../components/table/tableComponent";
import { FechamentoFinanceiroDTOModel } from "../../models/fechamentoFinanceiro/fechamentoFinanceiroDTOModel";
import { ButtonComponent } from "../../components/button/cadastrar";

dayjs.locale("pt-br");

const FechamentoFinanceiro = () => {
  //estados globais
  const fechamentoFinanceiroState = useAppSelector((state) => state.fechamentoFinanceiro);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const editar = Object.values(fechamentoFinanceiroState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("FECHAMENTO FINANCEIRO"));
    dispatch(buscarFechamentoFinanceiro(fechamentoFinanceiroState.busca));
    dispatch(buscarEmpresa(empresaState.busca));
  }, []);

  const filtroEmpresa = () =>
    Array.from(
      new Set<any>(
        empresaState.list.map((a: EmpresaModel) => ({
          text: a.apelido,
          value: a.apelido,
        }))
      )
    );

  const goCadastrar = () => {
    dispatch(setEntityFechamentoFinanceiro({}));
    dispatch(setModalCadastrarFechamentoFinanceiro(true));
  };

  const goEditar = (value: FechamentoFinanceiroDTOModel) => {
    dispatch(setEntityFechamentoFinanceiro(value));
    dispatch(setModalCadastrarFechamentoFinanceiro(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarFechamentoFinanceiro(false));
  };

  const onSearch = (value: string) => {
    let busca: BuscaFechamentoFinanceiroModel = { ...fechamentoFinanceiroState.busca, pesquisar: value };

    dispatch(setBuscaFechamentoFinanceiro(busca));
    dispatch(buscarFechamentoFinanceiro(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
  ];

  const columns: ColumnsType<FechamentoFinanceiroDTOModel> = [
    {
      title: "CONTA",
      dataIndex: "contaBanco",
    },
    {
      title: "EMPRESA",
      dataIndex: "empresa",
      align: "center",
      filters: filtroEmpresa(),
      onFilter: (value: any, record) => record.empresa.includes(value),
      sorter: (a, b) => a.empresa.localeCompare(b.empresa),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "FECHAMENTO MOVIMENTAÇÃO",
      dataIndex: "dataFechamentoMovimentacao",
      align: "center",
      render: (_, record) => <>{record.dataFechamentoMovimentacao && dayjs(record.dataFechamentoMovimentacao).format("DD/MM/YYYY")}</>,
    },
    {
      title: "FECHAMENTO CLASSIFICAÇÃO",
      dataIndex: "dataFechamentoClassificacao",
      align: "center",
      render: (_, record) => <>{record.dataFechamentoClassificacao && dayjs(record.dataFechamentoClassificacao).format("DD/MM/YYYY")}</>,
    },
    {
      title: "USUÁRIO",
      dataIndex: "nome",
      align: "center",
      sorter: (a, b) => (a.nome && b.nome ? a.nome.localeCompare(b.nome) : 0),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DATA ALTERACAO",
      dataIndex: "dataHoraAlteracao",
      align: "center",
      render: (_, record) => <>{record.dataHoraAlteracao && dayjs(record.dataHoraAlteracao).format("DD/MM/YYYY HH:mm")}</>,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Conta" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>

          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar}>FECHAR EMPRESA</ButtonComponent>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={fechamentoFinanceiroState.list} columns={columns} loading={fechamentoFinanceiroState.loading} rowKey="idContaBanco" />
      <Modal
        title={editar ? "EDITAR FECHAMENTO FINANCEIRO" : "FECHAMENTO FINANCEIRO"}
        centered
        width={800}
        open={fechamentoFinanceiroState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroFechamentoFinanceiro />
      </Modal>
    </Flex>
  );
};

export default FechamentoFinanceiro;
